import React from 'react';
import styled from 'styled-components';

const CheckboxContainer = styled.div`
  display: inline-block;
  vertical-align: middle;
`;

const Icon = styled.div`
  height: 16px;
  width: 16px;
  background-color: 4caf50;
  border: 2px solid white;
  border-radius: 50%;
`;

// Hide checkbox visually but remain accessible to screen readers.
// Source: https://polished.js.org/docs/#hidevisually
const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

interface Props {
  checked: boolean;
}

const StyledCheckbox = styled.div<Props>`
  display: flex;
  width: 24px;
  height: 24px;
  background-color: ${(props) =>
    props.checked ? '#4CAF50' : 'white'} !important;
  border-radius: 50%;
  border: ${(props) =>
    props.checked ? '2px solid #4CAF50' : '2px solid #2c2c2c'} !important;
  transition: all 150ms;
  box-sizing: border-box;
  justify-content: center;
  align-items: center;
  ${HiddenCheckbox}:focus + & {
    box-shadow: 0 0 0 3px white;
  }

  ${Icon} {
    visibility: ${(props) => (props.checked ? 'visible' : 'hidden')};
  }
`;

const RadioButton = ({ checked, ...props }) => (
  <CheckboxContainer>
    <HiddenCheckbox defaultValue={checked} {...props} />
    <StyledCheckbox checked={checked}>
      <Icon />
    </StyledCheckbox>
  </CheckboxContainer>
);

export default RadioButton;
